import { render, staticRenderFns } from "./config_zone_2.vue?vue&type=template&id=e8ba2d06&scoped=true"
import script from "./config_zone_2.vue?vue&type=script&lang=js"
export * from "./config_zone_2.vue?vue&type=script&lang=js"
import style0 from "./config_zone_2.vue?vue&type=style&index=0&id=e8ba2d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ba2d06",
  null
  
)

export default component.exports